<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%">
    <v-card>
      <v-toolbar dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-md-and-up" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Mitarbeiter bearbeiten</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text :disabled="!valid" v-show="$vuetify.breakpoint.sm" @click.native="updateUser">
            Mitarbeiter bearbeiten
            <v-icon right>save</v-icon>
          </v-btn>
          <v-btn icon :disabled="!valid" dark v-show="$vuetify.breakpoint.xs" @click.native="updateUser">
            <v-icon>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="E-Mail"
                  v-model="user.email"
                  :rules="emailRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-checkbox
                  v-model="showPwField"
                  label="Passwort"
                  color="primary"></v-checkbox>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  :type="showPassword ? 'text' : 'password'"
                  v-show="showPwField"
                  label="Passwort"
                  v-model="user.password"
                  :rules="passwordRules"
                  @click:append="showPassword = !(showPassword)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="roles"
                  v-model="user.role"
                  label="Rollen auswählen"
                  :rules="mandatoryFieldRule"
                  item-text="name"
                  item-value="id"
                  return-object
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="allCustomers"
                  v-model="user.customers"
                  chips
                  deletable-chips
                  :item-value="customerValue"
                  :item-text="customerText"
                  return-object
                  label="Kunden eingeben"
                  multiple
                >
                  <template v-slot:append-item
                  >
                    <v-divider></v-divider>
                    <v-list-item
                      ripple
                      @click="loadNextCustomerPage"
                    >
                      <v-list-item-content>
                        <v-list-item-title>Weitere Kunden laden</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="user.firstName"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname"
                  v-model="user.lastName"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Straße"
                  v-model="user.street"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  label="Postleitzahl"
                  v-model="user.zipCode"
                  :rules="zipCodeRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs9>
                <v-text-field
                  label="Stadt"
                  v-model="user.city"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">Abbrechen</v-btn>
        <v-btn
          :disabled="!valid"
          :loading="loading"
          color="primary"
          text
          @click.native="updateUser">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import debounce from 'debounce'
  import _ from 'lodash'

  export default {
    name: 'EditUserDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object,
        default: function () {
          return {
            email: '',
            password: '',
            role: null,
            customers: [],
            firstName: '',
            lastName: '',
            street: '',
            zipCode: '',
            city: ''
          }
        }
      }
    },
    data () {
      return {
        page: 0,
        size: 50,
        showPwField: false,
        showPassword: false,
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ],
        emailRules: [
          v => !!v || 'E-Mail nicht angegeben',
          v => /(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        ],
        passwordRules: [
          v => !!v || 'Passwort nicht angegeben',
          v => (v && v.length >= 8) || 'Ein Passwort muss min. 8 Zeichen enthalten',
          v => /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v) || 'Passwort muss enthalten: - min. ein Kleinbuchstaben - min. ein Großbuchstaben - min. eine Ziffer'
        ],
        zipCodeRules: [
          v => !!v || 'Postleitzahl nicht angegeben',
          v => (v && v.length === 5) || 'Die Postleitzahl muss genau 5 Zeichen lang sein'
        ]
      }
    },
    computed: {
      loading: function () {
        return this.$store.getters.loading
      },
      allCustomers: function () {
        return _.unionWith(this.user.customers.concat(this.$store.getters.customers), _.isEqual)
      },
      loadCustomers: function () {
        return debounce(this.fetchCustomers, 500)
      },
      roles: function () {
        return this.$store.getters.roles
      },
      valid () {
        return this.user.role !== null &&
          this.user.firstName !== '' &&
          this.user.lastName !== '' &&
          this.user.street !== '' &&
          this.user.zipCode !== '' &&
          this.user.city !== ''
      }
    },
    methods: {
      updateUser () {
        this.$store.dispatch('editUser', this.mapCustomers(this.mapRoles(this.user)))
          .finally(() => this.$emit('close'))
      },
      loadNextCustomerPage () {
        this.page++
        this.fetchCustomers()
      },
      fetchCustomers () {
        this.$store.dispatch('loadCustomers', {
          searchTerms: ''.split(' '),
          page: this.page,
          size: this.size
        })
      },
      mapRoles (user) {
        if (user.role.id) {
          user.role = this.roles[user.role.id - 1]
        } else {
          user.role = this.roles[user.role - 1]
        }
        return user
      },
      mapCustomers (user) {
        const customers = user.customers
        const customersArray = []

        customers.forEach(customer => {
          if (customer.id) {
            customersArray.push(this.allCustomers.find(c => c.id === customer.id))
          } else {
            customersArray.push(this.allCustomers.find(c => c.id === customer))
          }
        })
        user.customers = customersArray

        return user
      },
      customerValue (item) {
        return item.id
      },
      customerText (item) {
        return item.lastName + ' ' + item.firstName + ' - ' + item.street + ', ' + item.city
      },
      remove (item) {
        const foundIndex = this.user.customers.findIndex(customer => customer.id === item.id)
        if (foundIndex > -1) this.user.customers.splice(foundIndex, 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Users/EditUserDialog.vue